import { render } from "./tab.vue?vue&type=template&id=41656637"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__